import React from 'react'
import { useLocation } from 'react-router'

import { AppUrls } from 'common/AppUrls'
import { ReactComponent as KavkomLogo } from 'assets/svg/login/main_logo.svg'
import { ReactComponent as EmailIllustration } from 'assets/svg/password-recovery/email_illustration.svg'
import { ReactComponent as PasswordIllustration } from 'assets/svg/password-recovery/password_illustration.svg'
import { WhitelabelConfig } from 'hooks'

let Logo = KavkomLogo

if (WhitelabelConfig?.logo?.full) {
    const { url, width, height } = WhitelabelConfig.logo.full
    Logo = () => <img src={url} width={width} height={height} alt="Company logo" />
}

export const Logotypes = () => {
    const location = useLocation()
    const isResetPassword = location.pathname === AppUrls.resetPassword

    return (
        <div className="password-recovery__logotypes mb-3">
            <Logo />
            {isResetPassword ? (
                <PasswordIllustration className="password-recovery__logotypes--password" />
            ) : (
                <EmailIllustration className="password-recovery__logotypes--email" />
            )}
        </div>
    )
}
